import { render, staticRenderFns } from "./RefundConfirmation.vue?vue&type=template&id=24d04f0e&scoped=true&"
import script from "./RefundConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RefundConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./RefundConfirmation.vue?vue&type=style&index=0&id=24d04f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d04f0e",
  null
  
)

export default component.exports